import {common} from '@/Pages/Admin/Modules/Common/Services/Common.ts';
import { hotelApi } from '@/Pages/Admin/Modules/Hotel/Services/HotelApi';

class HotelService {
  // General Tab All Data API
  public async getGeneralTabData(payLoad: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("post", hotelApi.GetGeneral(), payLoad)
        .then((res: any) => {
          // console.log(res);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  // General Tab Put API
  public async PutGeneral(payLoad: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      // console.log("Put General", payLoad.trek_id);
      common
        .callApi1("put", hotelApi.PutGeneral(payLoad.hotel_id), payLoad)
        .then((res: any) => {
          // console.log(res);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  //get notice
  public async getNotice(payLoad: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("post", hotelApi.GetNotice(), payLoad)
        .then((res: any) => {
          // console.log(res.data.data);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public async updateNotice(payLoad: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      // console.log("Put General", payLoad.trek_id);
      common
        .callApi1("put", hotelApi.UpdateNotice(payLoad.hotel_id), payLoad)
        .then((res: any) => {
          // console.log(res);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  //get notice
  public async getTime(payLoad: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("post", hotelApi.GetTime(), payLoad)
        .then((res: any) => {
          // console.log(res.data.data);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public async updateTime(payLoad: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      // console.log("Put General", payLoad.trek_id);
      common
        .callApi1("put", hotelApi.UpdateTime(payLoad.hotel_id), payLoad)
        .then((res: any) => {
          // console.log(res);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  // Categories list for blog
  public async getCityList(): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("post", hotelApi.cityList())
        .then((res: any) => {
          // console.log(res.data.data);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public async addCity(payLoad: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("post", hotelApi.cityUpdate(), payLoad)
        .then((res: any) => {
          // console.log(res.data.data);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  //location tab
  public async getLocation(payLoad: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("post", hotelApi.GetLocation(), payLoad)
        .then((res: any) => {
          // console.log(res.data.data);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public async updateLocation(payLoad: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      // console.log("Put General", payLoad.trek_id);
      common
        .callApi1("put", hotelApi.UpdateLocation(payLoad.hotel_id), payLoad)
        .then((res: any) => {
          // console.log(res);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  /************************Hotel amenities start.*************************************/

  // get All hotel service List
  public async getAmenityList(payLoad: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("post", hotelApi.getAmenityList(), payLoad)
        .then((res: any) => {
          // console.log(res);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  //add service titel
  public async addAmenityTitle(payLoad: object): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("post", hotelApi.addAmenityTitle(), payLoad)
        .then((res: any) => {
          // console.log(res);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  // retrieve service
  public async retrieveAmenity(payLoad: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("post", hotelApi.getAmenity(), payLoad)
        .then((res: any) => {
          // console.log(res.data.data);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  //uplod service image
  public async addAminityImage(payLoad: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("post", hotelApi.addAmenityImage(), payLoad)
        .then((res: any) => {
          // console.log(res.data.data);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  //edit service
  public async editAmenityDetails(payLoad: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("put", hotelApi.editAmenity(), payLoad)
        .then((res: any) => {
          // console.log(res.data.data);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  /************************Hotel amenity end.*************************************/

  //start faq
  public async getFaqList(payLoad: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("post", hotelApi.FaqList(payLoad.hotel_id), payLoad)
        .then((res: any) => {
          // console.log(res);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public async addFaq(payLoad: object): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("post", hotelApi.AddFaq(), payLoad)
        .then((res: any) => {
          // console.log(res);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public async editFaq(payLoad: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("put", hotelApi.EditFaq(), payLoad)
        .then((res: any) => {
          console.log("Faq", res);
          // console.log(payLoad);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public async deleteSelectedFaq(payLoad: object): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("post", hotelApi.DeleteSelectedFaq(), payLoad)
        .then((res: any) => {
          // console.log(res);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  //get amenity

  public async amenityList(): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("get", hotelApi.amenityList())
        .then((res: any) => {
          // console.log(res);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public async addHotelAmenity(payLoad: object): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("post", hotelApi.addHotelAmenity(), payLoad)
        .then((res: any) => {
          // console.log(res);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public async allHotelAmenity(payLoad: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("post", hotelApi.allHotelAmenity(payLoad.hotel_id), payLoad)
        .then((res: any) => {
          // console.log(res);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public async editHotelAmenity(payLoad: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("put", hotelApi.editHotelAmenity(), payLoad)
        .then((res: any) => {
          console.log("edit", res);
          // console.log(payLoad);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  //delete hotel amenity
  public async deleteHotelAmenity(payLoad: object): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("post", hotelApi.deleteHotelAmenity(), payLoad)
        .then((res: any) => {
          // console.log(res);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  //delete hotel amenity
  public async removeHotelAmenityservice(payLoad: object): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("post", hotelApi.removeHotelAmenityservice(), payLoad)
        .then((res: any) => {
          // console.log(res);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public async allImageList(payLoad: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("post", hotelApi.ImageList(), payLoad)
        .then((res: any) => {
          // console.log(res);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public async makeBannerImage(payLoad: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("put", hotelApi.MakeBannerImage(), payLoad)
        .then((res: any) => {
          // console.log(res);
          // console.log(payLoad);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public async addGalleryImage(url: any, payLoad: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("post", url, payLoad)
        .then((res: any) => {
          // console.log(res);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public async deleteImage(payLoad: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("post", hotelApi.DeleteImage(), payLoad)
        .then((res: any) => {
          // console.log(res);
          // console.log(payLoad);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  /************************Hotel Room Start.*************************************/
  public async getRoomList(payLoad: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("post", hotelApi.getRoomList(), payLoad)
        .then((res: any) => {
          // console.log(res);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public async addRoomInfo(payLoad: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("post", hotelApi.addRoomInfo(), payLoad)
        .then((res: any) => {
          // console.log(res);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public async getRoomData(payLoad: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("post", hotelApi.GetGeneral(), payLoad)
        .then((res: any) => {
          // console.log(res);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public async getRoomInfo(payLoad: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("post", hotelApi.geRoomInfo(), payLoad)
        .then((res: any) => {
          // console.log(res);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public async updateRoomInfo(payLoad: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      // console.log("Put General", payLoad.trek_id);
      common
        .callApi1("put", hotelApi.updateRoomInfo(payLoad.hotel_id), payLoad)
        .then((res: any) => {
          // console.log(res);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  //hotel room image
  public async roomImageList(payLoad: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("post", hotelApi.roomImageList(), payLoad)
        .then((res: any) => {
          // console.log(res);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public async makeRoomBannerImage(payLoad: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("put", hotelApi.maekRoomBannerImage(), payLoad)
        .then((res: any) => {
          // console.log(res);
          // console.log(payLoad);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public async addRoomImage(url: any, payLoad: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("post", url, payLoad)
        .then((res: any) => {
          // console.log(res);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public async deleteRoomImage(payLoad: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("post", hotelApi.deleteRoomImage(), payLoad)
        .then((res: any) => {
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  //get hotel service

  public async serviceList(): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("get", hotelApi.serviceList())
        .then((res: any) => {
          // console.log(res);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  //hotel package
  public async roomPackageList(payLoad: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("post", hotelApi.roomPackageList(), payLoad)
        .then((res: any) => {
          // console.log(res);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public async addRoomPackage(payLoad: object): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("post", hotelApi.addRoomPackage(), payLoad)
        .then((res: any) => {
          // console.log(res);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  //room amenity
  public async addRoomAmenity(payLoad: object): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("post", hotelApi.addRoomAmenity(), payLoad)
        .then((res: any) => {
          // console.log(res);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public async roomAmenityList(payLoad: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("post", hotelApi.roomAmenityList(), payLoad)
        .then((res: any) => {
          // console.log(res);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public async editRoomAmenity(payLoad: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("put", hotelApi.editRoomAmenity(), payLoad)
        .then((res: any) => {
          console.log("edit", res);
          // console.log(payLoad);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  //delete room amenity
  public async deleteRoomAmenity(payLoad: object): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("post", hotelApi.deleteRoomAmenity(), payLoad)
        .then((res: any) => {
          // console.log(res);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  //delete room amenity
  public async removeRoomAmenityservice(payLoad: object): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("post", hotelApi.removeRoomAmenityservice(), payLoad)
        .then((res: any) => {
          // console.log(res);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  //paymet method
  public async addPaymentMethodHotel(payLoad: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("post", hotelApi.setPaymentMethod(), payLoad)
        .then((res: any) => {
          // console.log(res);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public async hotelPaymentList(payLoad: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("post", hotelApi.hotelPaymentList(payLoad.hotel_id), payLoad)
        .then((res: any) => {
          // console.log(res);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public async paymentChecked(payLoad: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("post", hotelApi.hotelPaymentList(payLoad.hotel_id), payLoad)
        .then((res: any) => {
          // console.log(res);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  //get notice
  public async getReservation(payLoad: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      common
        .callApi1("post", hotelApi.getReservation(), payLoad)
        .then((res: any) => {
          // console.log(res.data.data);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public async updateReservation(payLoad: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      // console.log("Put General", payLoad.trek_id);
      common
        .callApi1("put", hotelApi.upateReservation(payLoad.hotel_id), payLoad)
        .then((res: any) => {
          // console.log(res);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }
}

export const hotelService = new HotelService();